<div class="info-container">
  <div *ngIf="!hideLabel" class="info-container-label">{{ label$ | async }}</div>
  <ng-content></ng-content>
  <div class="submission-detail-grid">
    <ng-container *ngFor="let i of infoItems$ | async">
      <app-submission-detail
        *ngIf="!i.isSinField"
        [style.grid-column-start]="i.startNewRow ? 1 : null"
        [label]="i.infoLabel"
        [value]="i.value"
        [hasChanged]="true"
        [submissionState]="submissionInfoState" />
      <app-sin-submission-detail
        *ngIf="i.isSinField"
        [style.grid-column-start]="i.startNewRow ? 1 : null"
        [label]="i.infoLabel"
        [value]="i.value"
        [hasChanged]="true"
        [submissionState]="submissionInfoState" />
    </ng-container>
  </div>
</div>
